export const isBps = (rank?: string) => {
  if (!rank) {
    return false
  }

  return rank.includes('BPS')
}
